module.exports = __webpack_public_path__ + "static/media/home8.2c8bb7f5.jpg";